import { Link } from '@tanstack/react-router'

export function NoAccess() {
  return (
    <div data-slot="no-access" className="flex flex-col items-start gap-3 p-6">
      <h1 className="text-foreground text-lg font-semibold">No access</h1>
      <p className="text-muted-foreground text-sm">
        You don't have permission to view this page.
      </p>
      <Link to="/" className="text-primary text-sm font-medium hover:underline">
        Go to home
      </Link>
    </div>
  )
}
